import React from 'react';
import { User, Calendar, Clock, Globe, TrendingUp, ShieldCheck } from 'lucide-react';
import dubaiBusiness1 from '../../Assets/Images/dubai-business-1.webp';
import dubaiBusiness2 from '../../Assets/Images/dubai-business-2.jpg';

const BlogDubaiBusiness = () => {
    return (
        <article className="max-w-4xl mx-auto p-6 bg-white">
            <header className="h-[60vh] mt-40 flex justify-center items-center flex-col">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    Why Dubai is the Ultimate Destination for Entrepreneurs in 2024
                </h1>

                <div className="flex justify-center items-left gap-6 text-gray-600 mb-4 flex-col w-[100%]">
                    <div className="flex items-center gap-2">
                        <User size={18} />
                        <span>By James Carter</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <Calendar size={18} />
                        <span>Nov 25, 2024</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <Clock size={18} />
                        <span>7 min read</span>
                    </div>
                </div>
            </header>

            <div className="mb-8">
                <img
                    src={dubaiBusiness1}
                    alt="Dubai Business Skyline"
                    className="w-full rounded-lg aspect-[21/14]"
                />
                <p className="text-sm text-gray-500 mt-2">
                    Image: Dubai's iconic skyline, a hub for global business
                </p>
            </div>

            <div className="prose lg:prose-xl">
                <p className="text-lg text-gray-700 mb-6">
                    Dubai has positioned itself as one of the most dynamic and business-friendly cities in the world. Whether you are a budding entrepreneur or a seasoned business owner, this thriving emirate offers unmatched opportunities for growth, innovation, and success. In this article, we’ll explore the key reasons why establishing your business in Dubai could be your most rewarding decision in 2024.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                    A Strategic Location Like No Other
                </h2>
                <p className="text-lg text-gray-700 mb-6">
                    Dubai’s geographical location at the crossroads of Europe, Asia, and Africa makes it a strategic hub for global trade. The city offers access to over 2 billion people within a 4-hour flight radius. This unique positioning makes it ideal for businesses seeking to expand their reach into international markets.
                </p>

                <div className="my-8">
                    <img
                        src={dubaiBusiness2}
                        alt="Dubai Business Infrastructure"
                        className="w-full rounded-lg aspect-[21/14]"
                    />
                    <p className="text-sm text-gray-500 mt-2">
                        Image: State-of-the-art infrastructure for businesses in Dubai
                    </p>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                    Benefits of Doing Business in Dubai
                </h2>
                <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">
                    1. Tax-Free Policies
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                    One of Dubai’s biggest attractions for entrepreneurs is its tax-free policy. Corporate and personal income taxes are non-existent in many business zones, allowing companies to maximize profits.
                </p>

                <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">
                    2. Free Zones for Businesses
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                    Dubai boasts over 30 free zones tailored to various industries. These zones offer 100% foreign ownership, customs duty exemptions, and access to state-of-the-art facilities.
                </p>

                <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">
                    3. World-Class Infrastructure
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                    The city’s infrastructure is designed to support businesses of all sizes. With world-class transportation, modern office spaces, and advanced IT connectivity, Dubai provides a seamless working environment.
                </p>

                <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">
                    4. Safety and Stability
                </h3>
                <p className="text-lg text-gray-700 mb-6">
                    Dubai offers a secure and politically stable environment for businesses. Entrepreneurs can operate with peace of mind, knowing their investments are safeguarded.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
                    How to Get Started
                </h2>
                <p className="text-lg text-gray-700 mb-6">
                    Starting a business in Dubai is easier than ever. With the UAE government’s streamlined processes, entrepreneurs can establish their businesses in as little as one week. Here’s how:
                </p>
                <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-8">
                    <li>Choose your business structure and location (Free Zone or Mainland).</li>
                    <li>Register your company name and secure your trade license.</li>
                    <li>Set up your office space in one of Dubai’s premier business districts.</li>
                    <li>Apply for visas for yourself and your employees.</li>
                </ol>

                <div className="mt-8 flex justify-center">
                    <a
                        href="/contact"
                        className="bg-green-600 text-white px-6 py-3 rounded-lg text-xl hover:bg-green-700 transition duration-300"
                    >
                        Start Your Business in Dubai Now
                    </a>
                </div>
            </div>
        </article>
    );
};

export default BlogDubaiBusiness;
